<template>
    <div class="dashboard-filter">
        <v-autocomplete
          :items="items"
          item-value="merchantId"
          item-text="merchantName"
          v-model="merchant"
          outlined
          dense
          @change="merchantSelected"
          label="Merchants"
        ></v-autocomplete>
    </div>
</template>
<script>
export default {
    name: 'MerchantFilter',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            merchant: ''
        }
    },
    methods: {
        merchantSelected () {            
            const selectedMerchant = this.items.find(element => element.merchantId == this.merchant);
            this.$emit('merchantSelected', selectedMerchant)
        }
    }
}
</script>